import React from 'react';

export const LeftArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3586 2.89131C13.6027 3.13539 13.6027 3.53112 13.3586 3.7752L7.13388 9.99992L13.3586 16.2246C13.6027 16.4687 13.6027 16.8645 13.3586 17.1085C13.1145 17.3526 12.7188 17.3526 12.4747 17.1085L5.80806 10.4419C5.56398 10.1978 5.56398 9.80206 5.80806 9.55798L12.4747 2.89131C12.7188 2.64723 13.1145 2.64723 13.3586 2.89131Z"
        fill="#2A3B4C"
      />
    </svg>
  );
};
